import BusinessesShow from './businessesShow';
import BusinessesList from './businessesList';
import BusinessesEdit from './businessesEdit';

export default {
    show: BusinessesShow,
    list: BusinessesList,
    edit: BusinessesEdit,
}